//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetCurrentRecordIndex",{R_:{index:''}},0,0],[["index"],"SetCurrentRecordIndex",{},1,0],[["designRecord"],"AddSingleDesignRecord",{},1,0],[["designRecord","index"],"InsertDesignRecord",{},2,0],[["index"],"GetSingleDesignRecord",{R_:{designRecord:"Tooling.EjectorDesignData"}},1,0],[["editRecord"],"AddSingleEditRecord",{},1,0],[["editRecord","index"],"InsertEditRecord",{},2,0],[["index"],"GetSingleEditRecord",{R_:{editRecord:"Tooling.EjectorDesignData"}},1,0],[[],"GetCurrentDesignRecord",{R_:{currentEditRecord:"Tooling.EjectorDesignData"}},0,0],[[],"ClearDesignRecords",{},0,0],[[],"ClearEditRecords",{},0,0],[["index"],"EraseDesignRecord",{},1,0]],[]];
SPLM.Tooling.EjectorRecords = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.EjectorRecords";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;